import { ArtworkAifilterStyleDTO } from "@/types/filter";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Input, Space, Form } from "antd";
import { FC } from "react";

interface IProps {
  onAdd: (value: ArtworkAifilterStyleDTO) => void;
}

const AddOption: FC<IProps> = ({ onAdd }) => {
  const [form] = Form.useForm();
  const addItem = async () => {
    const values = await form.validateFields();
    onAdd(values);

    form.resetFields();
  }
  return (
    <>
      <Space style={{ padding: '0 8px 4px' }}>
        <Form form={form}>
          <Form.Item
            name="styleType"
            rules={[{ required: true, message: "" }]}
            help={null}
            style={{ margin: 0 }}
          >
            <Input
              placeholder="请输入"
              onKeyDown={e => e.stopPropagation()}
            />
          </Form.Item>
        </Form>

      </Space>
      <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
        添加标签
      </Button>
    </>
  )
}

export default AddOption;